export const APP_STATUS_STORE_KEY = 'appStatus';
